export default function MingButton({ text, link, newWindow, onClick }) {
  if (newWindow) {
    return (
      <div className="mingButton__buttonContainer" target="_blank" rel="noopener noreferrer">
        <span className="mingButton__buttonQuote">[ </span>
        <a className="mingButton__button" href={link} onClick={onClick}>
          <span className="mingButton__text">{text}</span>
          <span className="button__icon">
          </span>
        </a>
        <span className="mingButton__buttonQuote"> ]</span>
      </div>
    )
  }

  return (
    <div className="mingButton__buttonContainer">
      <span className="mingButton__buttonQuote">[ </span>
      <a className="mingButton__button" href={link} onClick={onClick}>
        <span className="mingButton__text">{text}</span>
        <span className="button__icon">
        </span>
      </a>
      <span className="mingButton__buttonQuote"> ]</span>
    </div>
  )
}